import { useEffect } from "react";
import { App } from "antd";
import { useDispatch } from "react-redux";

import { setShowFreeModal, setShowUpgradeModal } from "redux/Modals/actions";

import FreePlanDataset from "./FreePlanDataset";

function FreePlanModal({ showModal }: any) {
  const dispatch = useDispatch();
  const { modal } = App.useApp();

  useEffect(() => {
    if (!showModal) return;

    const instance = modal.warning({
      title: `You are on the Free Plan`,
      content: <FreePlanDataset showModal={showModal} />,
      width: 560,
      okText: "Upgrade",
      closable: true,
      onOk: () => {
        dispatch(setShowFreeModal(false));
        dispatch(setShowUpgradeModal(true));
      },
      onCancel: () => {
        dispatch(setShowFreeModal(false));
      },
    });

    return () => {
      instance.destroy();
    };
  }, [showModal, modal, dispatch]);

  return null;
}

export default FreePlanModal;
